import { render, staticRenderFns } from "./FooterDerek.vue?vue&type=template&id=cffd5e4c&"
import script from "./FooterDerek.vue?vue&type=script&lang=js&"
export * from "./FooterDerek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports